import { Link } from "react-router-dom";
import { channels } from "@/mocks/channels";
import { site } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-secondary-100">
      <div className="container-page grid grid-cols-1 gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-eye-2-line text-lg" aria-hidden="true" />
            </span>
            <strong className="font-heading text-lg font-bold text-foreground-950">{site.name}</strong>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">{site.intro}</p>
          <p className="mt-5 flex items-center gap-2 text-sm text-foreground-700">
            <i className="ri-mail-line text-primary-600" aria-hidden="true" />
            <a href={`mailto:${site.email}`} className="transition-colors hover:text-primary-700">
              {site.email}
            </a>
          </p>
          <p className="mt-2 flex items-center gap-2 text-sm text-foreground-700">
            <i className="ri-time-line text-primary-600" aria-hidden="true" />
            {site.workingHours}
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-foreground-900">栏目导航</h4>
          <ul className="mt-4 space-y-2.5">
            {channels.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/channel/${c.slug}`}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-bold text-foreground-900">关于本站</h4>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/channels" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                栏目总览
              </Link>
            </li>
            <li>
              <Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                常见问题
              </Link>
            </li>
            <li>
              <Link to="/contact" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                联系我们
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-secondary-200">
        <div className="container-page flex flex-col items-center justify-between gap-2 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} {site.name} · 内容均为公开信息整理与解读，不构成任何事实认定。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line" aria-hidden="true" />
            理性阅读 · 独立思考
          </p>
        </div>
      </div>
    </footer>
  );
}